module.exports = __webpack_public_path__ + "static/media/maintenance.4485fcbc.svg";